module.exports = __webpack_public_path__ + "img/OrangeMarigold.67262f89.png";